import {
  Box,
  Grid,
  GridItem,
  Heading,
  Text,
  VStack,
} from "@chakra-ui/react";
import Section from "./primary/Section";

const Home = () => {
  return (
    <Section id="about-expand" variant="cream">
      <Box py={{ base: 16, md: 24 }}>
        <Grid
          templateColumns={{ base: "1fr", lg: "1fr 1fr" }}
          gap={{ base: 10, lg: 16 }}
          alignItems="stretch"
        >
          <GridItem>
            <VStack align="start" spacing={6}>
              <Text
                fontSize="xs"
                letterSpacing="0.2em"
                textTransform="uppercase"
                color="cle.muted"
                fontWeight={600}
              >
                About
              </Text>
              <Heading
                as="h2"
                fontSize={{ base: "clamp(0.95rem, 5.6vw, 2.25rem)", md: "4xl" }}
                color="preview.neutral"
                whiteSpace="nowrap"
                lineHeight={1.05}
                letterSpacing="-0.02em"
              >
                CLE as a Community Living Lab
              </Heading>
              <Text color="cle.charcoal" fontSize="md" lineHeight={1.8}>
                CLE is currently being explored as a living lab. An evolving
                space where the relationships between different elements of the
                learning ecosystem are not predefined, but discovered through
                practice.
              </Text>
              <Text color="cle.muted" fontSize="md" lineHeight={1.8}>
                The aim is to better understand how these elements can interact
                in ways that support meaningful participation, evolving roles,
                and sustained engagement over time.
              </Text>
            </VStack>
          </GridItem>
          <GridItem display="flex" flexDirection="column">
            <Box
              flex="1"
              bg="cle.beige"
              borderRadius="2xl"
              p={{ base: 10, md: 12, lg: 14 }}
              boxShadow="sm"
              display="flex"
              alignItems="center"
              justifyContent="center"
              minH={{ base: "auto", lg: "100%" }}
            >
              <Text
                as="blockquote"
                fontSize={{ base: "lg", md: "xl" }}
                fontStyle="italic"
                fontFamily="heading"
                color="cle.charcoal"
                lineHeight={1.65}
                m={0}
              >
                Learning is not something delivered, but something that emerges
                through participation, relationships, and shared context.
              </Text>
            </Box>
          </GridItem>
        </Grid>
      </Box>
    </Section>
  );
};

export default Home;
